import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";
import { ShippingPlanCreatedBy } from "@deliverr/inbound-client";

export const selectCreatedByV1 = createSelector(
  selectCreateShipmentForm,
  (createShipment) => createShipment.createdBy === ShippingPlanCreatedBy.BOOKING_API
);
